import { AfterViewInit, Directive, Input, Self, SimpleChange } from '@angular/core';
import { TextAreaComponent } from '@progress/kendo-angular-inputs';

// Apply the same sizing policy without adding an attribute to every textarea.
/* eslint-disable @angular-eslint/directive-selector */
@Directive({
  selector: 'kendo-textarea',
  standalone: true,
})
export class TextareaSizingDirective implements AfterViewInit {
  private readonly initialRows: number = 3;

  constructor(@Self() private readonly textarea: TextAreaComponent) {
    this.textarea.rows = this.initialRows;
    this.textarea.resizable = 'auto';
  }

  ngAfterViewInit(): void {
    // Kendo 19 initializes its auto-resize baseline only when this input changes.
    // Measure after the three rows render, including fields without input bindings.
    this.textarea.ngOnChanges({
      resizable: new SimpleChange(undefined, 'auto', true),
    });
    this.textarea.writeValue(this.textarea.value);
  }

  // Also normalize existing template bindings, including changes between modes.
  @Input()
  set rows(value: number) {
    this.textarea.rows = this.normalizeRows(value);
  }

  @Input()
  set resizable(value: TextAreaComponent['resizable']) {
    this.textarea.resizable = this.normalizeResize(value);
  }

  private normalizeRows(value: number): number {
    return value === this.initialRows ? value : this.initialRows;
  }

  private normalizeResize(value: TextAreaComponent['resizable']): TextAreaComponent['resizable'] {
    return value === 'auto' ? value : 'auto';
  }
}